export default function Loader() {
  return (
    <div className="rounded-full border-4 border-gray-300 animate-spin duration-1000 w-12 h-12 absolute left-1/2 top-1/2 border-t-transparent"></div>
  );
}